// extracted by mini-css-extract-plugin
export default {"card":"ChartComponent_card__fucAl","card-body":"ChartComponent_card-body__OddfW","heading":"ChartComponent_heading__YAyQh"};